module.exports = __webpack_public_path__ + "static/media/add_theme2.7e29b1e9.svg";